/* eslint-disable no-shadow */
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/extranet-api/properties`;

const state = {
  group: null,
  pending: false,
  error: null,
  updatePending: false,
  updateError: null,
  propertiesPending: false,
  properties: [],
};

const getters = {
  properties: (state) => (state.propertiesPending ? state.properties : {}),
};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
  },

  beforePropertiesRequest(state) {
    state.propertiesPending = true;
  },
  afterPropertiesRequest(state, data) {
    state.propertiesPending = false;
    state.properties = data;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  // commit('update', err);
  throw err;
}

const actions = {
  async fetchAllProperties({ commit }, payload) {
    const page = payload?.page || 1;
    const perPage = payload?.perPage || 50;
    const filter = payload?.filter ? payload.filter : '';
    const order = payload?.order ? payload.order : 'createdAt';
    const sort = payload?.sort ? payload.sort : 'desc';
    const query = {
      page,
      perPage,
      filter,
      order,
      sort,
    };
    try {
      commit('beforePropertiesRequest');
      const data = await ApiService.post(`${endpoint}/all`, query);
      commit('afterPropertiesRequest', data);
      return data;
    } catch (error) {
      commit('afterPropertiesRequest', []);
      handleApiError(commit, error);
      return {};
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
